import { render, staticRenderFns } from "./ComponentInWorker.vue?vue&type=template&id=18855e8e&"
import script from "./ComponentInWorker.vue?vue&type=script&lang=js&"
export * from "./ComponentInWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports